<input
  #input
  type="text"
  matInput
  [value]="value || ''"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [attr.aria-labelledby]="parentFormField.getLabelId()"
  [required]="required"
  [matAutocomplete]="auto"
  [matAutocompleteConnectedTo]="connectedFormField()"
  maxlength="5"
  inputmode="tel"
  pattern="(?:[01]\d|2[0-3]):[0-5]\d"
  (input)="onInput($event)"
  (focus)="onFocus($event)"
  (keydown)="onKey($event)"
  (blur)="onBlur()"
/>

<mat-autocomplete #auto="matAutocomplete" [panelWidth]="panelWidth" (optionSelected)="onOptionSelected($event.option.value)" class="select__panel--surface">
  @for (opt of filteredOptions$ | async; let idx = $index; track idx) {
    <span
      [matTooltip]="getTooltip(opt)"
      [matTooltipDisabled]="!getTooltip(opt)"
      matTooltipPosition="right"
    >
    <mat-option
      [value]="opt"
      [disabled]="isOptionDisabledFor(opt)"
      class="without-checkbox"
    >
      {{ opt }}
    </mat-option>
  </span>
  }
</mat-autocomplete>